import React from "react";
import {
  Column,
  Container,
  Grid,
  Layout,
  RoutedSearchWrapper,
  SearchBox,
  SearchHitsColumns,
  SearchPagination,
  SearchRefinementList,
  Card,
} from "../components";
import { WpCardHit } from "../components/search/hits/";
import { Configure, connectStateResults } from "react-instantsearch-dom";

const featuredResource1 = {
  type: "resource",
  title: "2021 state of devops report",
  eyebrow: "Report",
  className: "pm-card--resource-report",
  link: {
    url: "/resources/report/2021-state-of-devops-report/",
  },
}

const featuredResource2 = {
  type: "resource",
  title: "Top Trends Impacting Infrastructure and Operations for 2021 - Gartner Report",
  eyebrow: "Report",
  className: "pm-card--resource-report",
  link: {
    url: "/resources/report/gartner-report-top-trends-impacting-infrastructure-and-operations-for-2021",
  },
};

const FeaturedResources = connectStateResults(
  ({ searchState }) => {
    let hasRefinements = false;
    if (searchState.refinementList) {
      hasRefinements = !Object.values(searchState.refinementList).every(x => x === null || x === '');
    }
    if (searchState.page !== 1 && searchState.page !== '1' && searchState.page !== undefined) {
      return ''
    }
    else if (searchState.query !== undefined && searchState.query !== '') {
      return ''
    }
    else if (hasRefinements) {
      return ''
    }
    else {
      return (<React.Fragment>
        <Column aboveMd={{span: 6}}>
          <Card {...featuredResource1} />
        </Column>
        <Column aboveMd={{span: 6}}>
          <Card {...featuredResource2} />
        </Column>
      </React.Fragment>)
    }
  }
);

const pageMeta = {
  title: "Resources",
  description: "Learn more about Puppet infrastructure automation with our Resource Library.",
  canonicalUrl: 'https://puppet.com/resources/'
};

const MultiIndexSearch = () => (
  <Layout meta={pageMeta}>
    <Container className="pm-margin-top--xl pm-margin-bottom--lg pm-resources">
      <h1 className="pm-font-size--h2 pm-margin-bottom--lg">Resources</h1>
      <RoutedSearchWrapper indexName="prod_gatsby_resources">
        <Configure hitsPerPage={18} />
        <Grid>
          <Column aboveSm={{ span: 3 }} className="pm-resources__sidebar">
            <SearchBox placeHolder="Search" />
            <h5 className="pm-margin-top--md pm-margin-bottom--sm">Product</h5>
            <SearchRefinementList attribute="products.name" />
            <h5 className="pm-margin-top--md pm-margin-bottom--sm">Industry</h5>
            <SearchRefinementList attribute="industry.name" />
            <h5 className="pm-margin-top--md pm-margin-bottom--sm">Type</h5>
            <SearchRefinementList attribute="type" />
            <h5 className="pm-margin-top--md pm-margin-bottom--sm">Use case</h5>
            <SearchRefinementList attribute="usecase.name" />
          </Column>
          <Column aboveSm={{ span: 9 }}>
            <Grid alignRowItemHeights={true} className="resource-cards">
              <FeaturedResources/>
              <SearchHitsColumns
                hitComponent={WpCardHit}
                columnProps={{ aboveMd: { span: 4 } }}
              />
            </Grid>
            <SearchPagination basePath="/resources" />
          </Column>
        </Grid>
      </RoutedSearchWrapper>
    </Container>
  </Layout>
);

export default MultiIndexSearch;
